import { useState } from "react";
import { InvalidInputMessage } from "./invalid-input";

export function PasswordInput({
  name = "password",
  value,
  onChange,
  placeholder = "Password",
  error
}) {
  const [show, setShow] = useState(false);
  const [focus, setFocus] = useState(false);

  return (
    <div className="mb-3">
      <div className={[
        "w-full h-[50px] flex items-center px-4",
        "rounded-[16px] bg-background-secondary",
        "ring-1 ring-[#34353F]",
          focus ? " outline-none ring-2 ring-white " : "  ",
        error ? "ring-chilli" : ""
      ].join(" ")}>
        <input
          type={show ? "text" : "password"}
          name={name}
          value={value ?? ""}
          onChange={onChange}
          placeholder={placeholder}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          className="w-full bg-transparent outline-none text-white/90 placeholder:text-white/50 font-body-primary text-base"
        />
        <button
          type="button"
          onClick={() => setShow(s => !s)}
          className="ml-2 w-8 h-8 grid place-items-center rounded-lg hover:bg-white/5"
          aria-label={show ? "Hide password" : "Show password"}
        >
          <i className={`bi ${show ? "bi-eye-slash" : "bi-eye"} text-[18px] text-white/80`}></i>
        </button>
      </div>
      <InvalidInputMessage errorMessage={error} />
    </div>
  );
}
